// extracted by mini-css-extract-plugin
module.exports = {"nextArrow":"_6a39eb6","prevArrow":"_009f60d","outside":"_f8ba170"};